import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import React from "react";

import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import clsx from "clsx";
import PropTypes from "prop-types";
import useStyles from "./styles";

function UserCardMenu({ onEdit, id, onOpenChangePassword, onOpenSignature, privileges }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const classes = useStyles();

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleEdit() {
        handleClose();
        onEdit(id);
    }

    function handleOpenChangePassword() {
        handleClose();
        onOpenChangePassword(id);
    }
    function handleOpenChangeSignature() {
        handleClose();
        onOpenSignature(id);
    }

    const { canChangePassword, canEdit, canEditSign } = privileges;

    if (!canEdit && !canChangePassword && !canEditSign) {
        return <div style={{ height: 56 }} />;
    }

    return (
        <>
            <IconButton color="black" aria-label="settings" style={{ zIndex: 999 }} onClick={handleOpen}>
                <MoreVertIcon className={classes.optionButton} />
            </IconButton>
            <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                {canEdit && <MenuItem onClick={handleEdit}>Edit</MenuItem>}
                {canChangePassword && (
                    <MenuItem type={"text"} onClick={handleOpenChangePassword}>
                        Change password
                    </MenuItem>
                )}
                {canEditSign && (
                    <MenuItem type={"text"} onClick={handleOpenChangeSignature}>
                        Change signature
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}

UserCardMenu.propTypes = {
    onEdit: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    onOpenChangePassword: PropTypes.func.isRequired,
    onOpenSignature: PropTypes.func.isRequired,
    privileges: PropTypes.object.isRequired,
};
function UserCard({ user, onEdit, onOpenChangePassword, onOpenSignature, children }) {
    const classes = useStyles();
    const isForm = !!children;

    const content = isForm ? (
        <div className={classes.content}>{children}</div>
    ) : (
        <div className={classes.content}>
            <Typography variant="h6" color="textSecondary" component="div" className={clsx(classes.center, "wrapText")}>
                {user.username}
            </Typography>
            <Typography
                variant="subtitle1"
                color="textSecondary"
                component="div"
                className={clsx(classes.center, "block-ellipsis-2-lines")}
            >
                {user.firstName} {user.lastName}
            </Typography>
        </div>
    );
    const iconUser = isForm ? null : (
        <div className={classes.iconUser}>
            {!user.active ? (
                <Tooltip title="Inactive">
                    <NotInterestedOutlinedIcon color={"disabled"} />
                </Tooltip>
            ) : user.isAdmin ? (
                <Tooltip title="Administrator">
                    <SupervisorAccountOutlinedIcon />
                </Tooltip>
            ) : null}
        </div>
    );
    const action = isForm ? (
        <div style={{ height: 56 }} />
    ) : (
        <UserCardMenu
            id={user.id}
            onEdit={onEdit}
            privileges={user.privileges}
            onOpenSignature={onOpenSignature}
            onOpenChangePassword={onOpenChangePassword}
        />
    );

    const styles = { position: "relative" };
    if (!user.active) {
        styles.opacity = 0.65;
    }
    return (
        <Card className={classes.root} raised style={styles}>
            {iconUser}
            <CardHeader action={action} />

            <CardContent className={classes.contentRoot}>
                <div className={classes.avatar}>
                    <Avatar className={classes.largeAvatar} style={{ backgroundColor: user.avatarColor }}>
                        {user.avatarText}
                    </Avatar>
                </div>
                {content}
            </CardContent>
        </Card>
    );
}

UserCard.propTypes = {
    user: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    onOpenChangePassword: PropTypes.func.isRequired,
    onOpenSignature: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default UserCard;
